<script lang="ts" setup>
import { useModal } from "vue-final-modal";
import DemoLMSInfo from "~/components/Demos/LMSInfo.vue";

const userClassroomDataStore = useUserClassroomsDataStore();
const {
  visibleClassrooms,
  userClassrooms,

  hasOtherUserClassrooms,
  otherUserClassrooms,
} = storeToRefs(userClassroomDataStore);

const appUserStore = useAppUserDataStore();
const { demoMode, isPublicDemo, showOtherUsersClassrooms, hasIEWLMS } =
  storeToRefs(appUserStore);

const tabs = ref<Tabs>([
  {
    label: "IEW Gradebook",
    key: "iew",
  },
  {
    label: "3rd Party LMS",
    key: "google",
  },
]);

const showLMSExplanationModal = () => {
  const { open, close } = useDialog({
    component: DemoLMSInfo,
    props: {
      onClose: () => {
        close();
      },
    },
  });

  open();
};
</script>

<template>
  <div
    v-if="userClassrooms"
    class="flex flex-col w-full h-full min-h-0"
    v-auto-animate
  >
    <div
      v-if="userClassrooms.length == 0 && showOtherUsersClassrooms == false"
      class="grow flex flex-col min-h-0 pb-2"
    >
      <BaseEmptyListMessage class="h-full">
        <div class="flex flex-col items-center gap-2 justify-center">
          No Classrooms
          <NuxtLink to="/configure/lms/classrooms">
            <BaseOutlinedButton color="secondary" class="text-body-1">
              {{ hasIEWLMS() ? "Add Classrooms" : "Sync Classrooms" }}
            </BaseOutlinedButton>
          </NuxtLink>
        </div>
      </BaseEmptyListMessage>
    </div>

    <div
      v-for="classroom of userClassrooms"
      :key="classroom.id"
      class="mb-2 last:mb-0 border-b last:border-b-0 pb-2"
    >
      <ClassroomFoldersListItem :classroom="classroom" />
    </div>

    <div
      v-if="showOtherUsersClassrooms && hasOtherUserClassrooms"
      class="flex flex-col"
    >
      <!-- <h2 class="text-body-1 pl-2 mb-2">Other Classrooms</h2> -->
      <div
        v-for="classroom of otherUserClassrooms"
        :key="classroom.id"
        class="border-b last:border-b-0"
      >
        <ClassroomFoldersListItem :classroom="classroom" />
      </div>
    </div>

    <div
      v-if="isPublicDemo"
      class="flex flex-col m-1 border-2 border-primary-default border-dashed rounded p-2"
    >
      <p class="text-left px-1 mb-2">
        This is what IEW Gradebook classrooms looks like when students directly
        submit to
      </p>
      <div
        class="mb-2 border rounded border-primary-default p-2 text-center cursor-pointer hover:bg-primary-default hover:bg-opacity-20"
        :class="{
          ' text-primary-on bg-primary-default !hover:bg-opacity-40':
            demoMode === 'iew',
          ' text-primary-default bg-surface': demoMode != 'iew',
        }"
        @click="demoMode = 'iew'"
      >
        IEW Gradebook
      </div>
      <div
        class="mb-2 border rounded border-primary-default p-2 text-center cursor-pointer hover:bg-primary-default hover:bg-opacity-20"
        :class="{
          ' text-primary-on bg-primary-default !hover:bg-opacity-40':
            demoMode === 'google',
          ' text-primary-default bg-surface': demoMode != 'google',
        }"
        @click="demoMode = 'google'"
      >
        Google Classroom
      </div>
      <div />
      <BaseTextButton @click="showLMSExplanationModal">
        Learn More
      </BaseTextButton>
    </div>
  </div>
</template>

<style scoped></style>
